import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAnalytics } from "@/utils/analytics";
import { captureAttribution } from "@/utils/attribution";

captureAttribution();

initAnalytics();

// Module 11 Phase A — Service Worker for PWA install compliance.
// Push handling is added in Phase B; this only enables the install
// prompt + safe static-asset caching (see /public/service-worker.js).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => { /* silent */ });
    // Handle deep-link navigations posted from the service worker
    // (arriving in Phase B when push tap opens the app).
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'navigate' && event.data.target) {
        window.location.href = event.data.target;
      }
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
